function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgSettingsNotices = function SvgSettingsNotices(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    role: "img",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.28,25c-3.11-2.26-3.35-2.46-4.06-3a.54.54,0,0,1-.22-.44v-.45A1.12,1.12,0,0,1,12.12,20h9.76A1.12,1.12,0,0,1,23,21.12v.45a.54.54,0,0,1-.22.44c-.71.57-1,.76-4.06,3-.39.29-1.18,1-1.72,1S15.67,25.32,15.28,25Zm7.72-2v4.8A1.12,1.12,0,0,1,21.88,29H12.12A1.12,1.12,0,0,1,11,27.88v-4.8a.14.14,0,0,1,.23-.11c.52.41,1.22.93,3.61,2.67A4.14,4.14,0,0,0,17,26.75a4.17,4.17,0,0,0,2.16-1.11c2.39-1.74,3.09-2.26,3.61-2.67A.15.15,0,0,1,23,23.08Z",
    style: {
      fill: "#666"
    }
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39,24.12c0,2.7-2.69,4.88-6,4.88a7.14,7.14,0,0,1-2.52-.46,5.33,5.33,0,0,1-3.29,1.21.18.18,0,0,1-.17-.11.2.2,0,0,1,0-.21,6,6,0,0,0,1.29-2.24A4.32,4.32,0,0,1,27,24.12c0-2.69,2.69-4.87,6-4.87S39,21.43,39,24.12Z",
    style: {
      fill: "#666"
    }
  }))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSettingsNotices, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/settings-notices.91f7fc35.svg";
export { ForwardRef as ReactComponent };